/** Cookie / analytics preference stored in localStorage (not a tracking cookie). */

export const COOKIE_CONSENT_KEY = "attenzio_cookie_consent";
export const COOKIE_CONSENT_VERSION = 1;

export type CookieConsentChoice = "accepted" | "rejected";

export type CookieConsentRecord = {
  choice: CookieConsentChoice;
  version: number;
  updatedAt: string;
};

export function readCookieConsent(): CookieConsentRecord | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CookieConsentRecord;
    if (parsed?.choice !== "accepted" && parsed?.choice !== "rejected") return null;
    if (parsed.version !== COOKIE_CONSENT_VERSION) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeCookieConsent(choice: CookieConsentChoice): CookieConsentRecord {
  const record: CookieConsentRecord = {
    choice,
    version: COOKIE_CONSENT_VERSION,
    updatedAt: new Date().toISOString(),
  };
  localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(record));
  window.dispatchEvent(new CustomEvent("attenzio:cookie-consent", { detail: record }));
  return record;
}

export function hasAnalyticsConsent(): boolean {
  return readCookieConsent()?.choice === "accepted";
}
